import { render } from "./ConcessionaireSetupPage.vue?vue&type=template&id=3c8b6299"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__